import styled from 'styled-components';
import Form from '../../Form/Form';

const FlexRow = styled.div`
  display: flex;
  gap: 20px;

  .ant-form-item {
    margin-bottom: 20px;
    width: 100%;
  }
`;

const FlexRowNoMargin = styled(FlexRow)`
  .ant-form-item {
    margin-bottom: 0;
  }
`;

const ModalDescription = styled.p`
  color: var(--greyscale-shade);
  font-size: var(--font-size-regular);
  line-height: var(--font-line-height-regular);
  margin: 0 0 24px;
`;

const NoMarginFormItem = styled(Form.Item)`
  && {
    margin-bottom: 0;
  }
`;

const OrgLevelFormItem = styled(Form.Item)`
  && {
    margin-top: 20px;
  }
`;

const RoleFormItem = styled(Form.Item)`
  && {
    margin-bottom: 0;
    margin-top: ${({ $mt }) => $mt}px;
    width: 50%;
  }
`;

const StatusFormItem = styled(Form.Item)`
  && {
    margin-bottom: 0;
    margin-top: 20px;
  }
`;

const AddEditModalLayout = {
  FlexRow,
  FlexRowNoMargin,
  ModalDescription,
  NoMarginFormItem,
  OrgLevelFormItem,
  RoleFormItem,
  StatusFormItem
};

export default AddEditModalLayout;
